import React from "react";
import "./App.css";
import SmokeRavenNavbar from "./js/components/Navigation";

function App() {
  return (
    <div className="App">
      <SmokeRavenNavbar />
    </div>
  );
}

export default App;
